/**
 * Constants used in display decision logic
 */
export const TAX_CONSTANTS = {
  MSNBC: {
    VERTICAL: 'nbcnews/vertical/msnbc',
    SECTION_OPINION: 'nbcnews/section/opinion',
    SECTION_COLUMNIST: 'nbcnews/section/featured-columnist',
  },
};

/**
 * Test if sections contain given string slug value
 * @param {Array} sections
 * @param {String} keyword
 * @returns {Boolean}
 */
export const sectionContainSlug = (sections, keyword) => {
  if (!Array.isArray(sections)) {
    return false;
  }
  return sections.some((section) => (section && section.slug === keyword));
};

/**
 * Test if given value meets minimum requirement of being taxonomy term
 * @param {Object} term
 * @returns {Boolean}
 */
export const isTaxonomyTerm = (term) => !!term && typeof term === 'object' && typeof term.id === 'string';

/**
 * Pull [key] from taxonomy term structure and return a flat array
 * @param {Object} taxonomy
 * @returns {Array}
 */
const extractTermsValuesByKey = (taxonomy, key) => {
  // Return term[key]
  if (isTaxonomyTerm(taxonomy)) {
    return taxonomy[key];
  }
  let terms = [];
  if (typeof taxonomy === 'object') {
    // Object containing all taxonomy terms
    Object.values(taxonomy).forEach((row) => {
      // Is array of multiple terms
      if (Array.isArray(row) && row.length) {
        terms = [...terms, ...extractTermsValuesByKey(row, key)];
      // Is single term
      } else if (isTaxonomyTerm(row)) {
        terms.push(row[key]);
      }
    });
  }
  // Return uniques
  return terms.filter((value, index, self) => self.indexOf(value) === index);
};

/**
 * Pull ids from taxonomy term structure and return a flat array
 * @param {Object} taxonomy
 * @returns {Array}
 */
export const extractTermIds = (taxonomy) => extractTermsValuesByKey(taxonomy, 'id');

/**
 * Pull paths from taxonomy term structure and return a flat array
 * @param {Object} taxonomy
 * @returns {Array}
 */
export const extractTermPaths = (taxonomy) => extractTermsValuesByKey(taxonomy, 'path');
